var _path, _path2, _g, _path3, _path4, _path5, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMedal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 107,
    viewBox: "0 0 62 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.4934 0L25.7659 49.9222H41.125L61.9997 0H45.4934Z",
    fill: "#6359CF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_246_5966",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 46,
    width: 54,
    height: 61
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.8877 46.8262H58.5133V106.245H5.8877V46.8262Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_246_5966)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.9746 55.5311V51.1851C21.9746 50.4785 22.5482 49.9029 23.253 49.9029H41.148C41.8529 49.9029 42.4264 50.4785 42.4264 51.1851V55.5311C39.2829 54.2 35.8273 53.464 32.2005 53.464C28.5737 53.464 25.1182 54.2 21.9746 55.5311ZM45.4945 57.0749V51.1851C45.4945 48.7815 43.5445 46.8262 41.148 46.8262H23.253C20.8565 46.8262 18.9069 48.7815 18.9069 51.1851V57.0749C11.1177 61.6571 5.8877 70.1434 5.8877 79.8546C5.8877 94.4299 17.6681 106.245 32.2005 106.245C46.7326 106.245 58.5133 94.4299 58.5133 79.8546C58.5133 70.1434 53.2836 61.6571 45.4945 57.0749Z",
    fill: "url(#paint0_linear_246_5966)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.2075 101.455C20.2197 101.455 10.4675 91.8831 10.4675 80.1174C10.4675 68.351 20.2197 58.7793 32.2075 58.7793C44.1954 58.7793 53.9482 68.351 53.9482 80.1174C53.9482 91.8831 44.1954 101.455 32.2075 101.455Z",
    fill: "url(#paint1_linear_246_5966)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.2698 88.5718L32.5643 85.751L25.8334 88.5098L26.4149 81.1905L21.74 75.5714L28.805 73.8682L32.6463 67.6367L36.431 73.9037L43.4803 75.6717L38.7546 81.2474L39.2698 88.5718Z",
    fill: "#FFEFB9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H18.3338L41.8703 50.7274H24.6526L0 0Z",
    fill: "#7367F0"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_246_5966",
    x1: 26.6126,
    y1: 39.1504,
    x2: -5.01253,
    y2: 84.9983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDE78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBA3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_246_5966",
    x1: 30.1078,
    y1: 50.8995,
    x2: 4.70068,
    y2: 84.8784,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD06D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F99912"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedal);
export default __webpack_public_path__ + "static/media/medal.0146a4b0fe37e5b4d6656bcc1ece8b9b.svg";
export { ForwardRef as ReactComponent };